import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BaseService } from "../base.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class NoteService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("note");
  }
}



// WEBPACK FOOTER //
// ./src/app/note/note.service.ts